export default process.env.NODE_ENV !== 'production'
  ? 'https://2495e5222c3f4671b9502cda9ada8f32@sentry.io/1409905'
  : 'https://34044610587241b3b1b7ae08156430fd@sentry.io/1537302'
